import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import {OrganizationData} from "./interface";
import {OrganizationSelector} from "./props/organization_selector";
import {OrganizationContent, OrganizationMenu} from "./props/organization_content";
import axios from "axios";
import qs from "qs";
import { OrgSubAccounts } from './props/org_sub_account';
import Swal from 'sweetalert2'
import jQuery from 'jquery';
declare var organization_data:OrganizationData;

export class OrganizationInterface extends React.Component<any, any> {
    constructor(props:any) {
        super(props);

        var current_organization = 0;
        if( organization_data.hasOwnProperty('curr_organization') && organization_data.curr_organization != "" ) {
            current_organization = organization_data.curr_organization;
        }

        this.state = {
            curr_organization: current_organization,
            active_menu: 'info'
        }
    }

    organizationSelected = (e: any) => {
        const _value = e.target.value;
        e.preventDefault();

        //ajax request to set selected organization
        axios.post( organization_data.admin_ajax, qs.stringify(  {
            action: 'set_selected_organization',
            req_nonce: organization_data.req_nonce,
            org_id: _value,
        })).then( (response:any) => {
            if( response ) {
                if( response.data && response.data.success ) {
                    this.setState({ curr_organization: _value });
                    if(_value == ""){
                        if( 
                            [
                                'my-account/people',
                                'my-account/create-sub-account',
                            ].map( (item) => {
                                return window.location.href.indexOf( item ) > -1;
                            } ).includes( true )
                        ) {
                            //redirect to /my-account
                            const redirectUrl = window.location.origin + '/my-account';
                            
                            // Navigate to the modified URL
                            window.location.href = redirectUrl;
                        } else {
                            window.location.reload();
                        }
                    } else {
                        //refresh page if there is "my-account/orders" in the url
                        if( 
                            [
                                'my-account/orders',
                                'my-account/people',
                                'my-account/create-sub-account',
                            ].map( (item) => {
                                return window.location.href.indexOf( item ) > -1;
                            } ).includes( true )
                        ) {
                            const removeNumericParamsFromUrl = (url: string): string => {
                                const regex = /\/\d+(\/|$)/g;
                                return url.replace(regex, '/');
                            }
                            const url = window.location.href;
                            const modifiedUrl = removeNumericParamsFromUrl(url);
                            
                            // Navigate to the modified URL
                            window.location.href = modifiedUrl;
                        } else {
                            window.location.reload();
                        }
                    }
                } else {
                    this.setState({ curr_organization: this.state.curr_organization });
                    Swal.fire({
                        title: 'Error',
                        text: response.data?.message ?? 'An error occurred',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            } else {
                this.setState({ curr_organization: this.state.curr_organization });
            }
        } ).catch( error => {
            console.error( 'Error', error );
        } ).finally(() => {
            // if (_value == "") return;
        });
        
    }

    organizationMenu = (e:any) => {
        const _menu = e.currentTarget.dataset.menuItem;
        if( _menu ) {
            this.setState( { active_menu: _menu } );
        }
    }

    render() {
        var organizationList:any = [];
        if( organization_data.hasOwnProperty( 'organizations' )  ) {
            organizationList = organization_data.organizations;
        }
        return (
            <div>
                <OrganizationSelector valueSelected={this.organizationSelected} organizationList={organizationList} initialValue={this.state.curr_organization}/>
                {
                    this.state.curr_organization !== '' ? 
                    <OrganizationContents setMenuItem={this.organizationMenu} activeItem={this.state.active_menu} currOrganization={this.state.curr_organization}/>  
                    : <></>
                }
                <OrganizationSelectorMobile valueSelected={this.organizationSelected} organizationList={organizationList} initialValue={this.state.curr_organization}/>
                <OrganizationSubAccount currOrganization={this.state.curr_organization}/>
            </div>
        ); 
    }
}

interface OrganizationSubAccountProps {
    currOrganization: any;
}

export const OrganizationSubAccount: React.FC<OrganizationSubAccountProps> = ({ currOrganization }) => {
    const portalRootId = 'create-sub-account-react-root';
    const portalRootRef = useRef<HTMLDivElement | null>((document.getElementById(portalRootId) as HTMLDivElement | null) ?? null);

    useEffect(() => {
        const portalRoot = document.getElementById(portalRootId) as HTMLDivElement | null;
        portalRootRef.current = portalRoot;

        return () => {
            portalRootRef.current = null;
        };
    }, []);

    if (!portalRootRef.current) {
        return null; // Exit early if the portal root does not exist
    }

    const renderPortalContent = () => {
        console.log('OrganizationSubAccount');
        return (<OrgSubAccounts currOrganization={currOrganization} />)
    };

    return ReactDOM.createPortal(renderPortalContent(), portalRootRef.current);
};

interface OrganizationSelectorMobileProps {
    valueSelected: (e: any) => void;
    organizationList: any;
    initialValue: string;
}

export const OrganizationSelectorMobile: React.FC<OrganizationSelectorMobileProps> = ({ valueSelected, organizationList, initialValue }) => {
    const portalRootId = 'organization_ui_hook_menu';
    const portalRootRef = useRef<HTMLDivElement | null>((document.getElementById(portalRootId) as HTMLDivElement | null) ?? null);

    useEffect(() => {
        const portalRoot = document.getElementById(portalRootId) as HTMLDivElement | null;
        portalRootRef.current = portalRoot;

        return () => {
            portalRootRef.current = null;
        };
    }, []);

    if (!portalRootRef.current) {
        return null; // Exit early if the portal root does not exist
    }

    const renderPortalContent = () => {
        return (<OrganizationSelector valueSelected={valueSelected} organizationList={organizationList} initialValue={initialValue}/>)
    };

    return ReactDOM.createPortal(renderPortalContent(), portalRootRef.current);
};


interface OrganizationContentsProps {
    activeItem: string;
    setMenuItem: (menuItem: string) => void;
    currOrganization: string;
}

export const OrganizationContents: React.FC<OrganizationContentsProps> = ({ activeItem, setMenuItem, currOrganization }) => {
    const portalRootId = 'organization_ui_body_hook';
    const portalRootRef = useRef<HTMLDivElement | null>((document.getElementById(portalRootId) as HTMLDivElement | null) ?? null);

    useEffect(() => {
        const portalRoot = document.getElementById(portalRootId) as HTMLDivElement | null;
        portalRootRef.current = portalRoot;

        return () => {
            portalRootRef.current = null;
        };
    }, []);

    if (!portalRootRef.current) {
        return null; // Exit early if the portal root does not exist
    }

    const renderPortalContent = () => {
        return (<div className="organization_contents">
                <OrganizationMenu setMenuItem={setMenuItem} activeItem={activeItem} currOrganization={currOrganization} />
                <OrganizationContent activeItem={activeItem} currOrganization={currOrganization} />
            </div>)
    };

    return ReactDOM.createPortal(renderPortalContent(), portalRootRef.current);
};